import { ExclamationCircleOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { useNavigate } from 'react-router';
import { useAccountSelector, useFindAccountStatus } from 'src/hooks';
import { Display, JustifyContent } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';

import * as Styles from './AccountStatusBanner.styles';

export const AccountStatusBanner = () => {
  const navigate = useNavigate();
  const { account } = useAccountSelector();
  const { status, isAnyDocumentRequested } = useFindAccountStatus({
    skip: true,
  });

  const findType = () =>
    status?.isPending || status?.isPendingEntityActivation || status?.isPendingLinkError ? 'warning' : 'error';

  const findMessage = () => {
    if (status?.isRejected && isAnyDocumentRequested) {
      return (
        <MTypography variant='subtitle1' weight='semibold' inline>
          Your account has been rejected. Before we can approve your account, we will need additional information.
          Please visit{' '}
          <a
            onClick={() => {
              navigate(`/accounts/${account?.id}/account-status`);
            }}>
            Account Status
          </a>{' '}
          to submit the required information.
        </MTypography>
      );
    }

    if (status?.isRejected) {
      return (
        <MTypography variant='subtitle1' weight='semibold' inline>
          Your account has been rejected. You can find more information at{' '}
          <a
            onClick={() => {
              navigate(`/accounts/${account?.id}/account-status`);
            }}>
            Account Status
          </a>
          .
        </MTypography>
      );
    }

    if (status?.isPendingLinkError) {
      return (
        <MTypography variant='subtitle1' weight='semibold' inline>
          An unexpected account linking error occurred. You can find more information at{' '}
          <a
            onClick={() => {
              navigate(`/accounts/${account?.id}/account-status`);
            }}>
            Account Status
          </a>
          .
        </MTypography>
      );
    }

    if (isAnyDocumentRequested) {
      return (
        <MTypography variant='subtitle1' weight='semibold' inline>
          Before we can approve your account, we will need additional information. Please visit{' '}
          <a
            onClick={() => {
              navigate(`/accounts/${account?.id}/account-status`);
            }}>
            Account Status
          </a>{' '}
          to submit the required information.
        </MTypography>
      );
    }

    return (
      <MTypography variant='subtitle1' weight='semibold' inline testId='account-submitted-banner'>
        Your account application has been submitted and is under review. You can find more information at{' '}
        <a
          onClick={() => {
            navigate(`/accounts/${account?.id}/account-status`);
          }}>
          Account Status
        </a>
        .
      </MTypography>
    );
  };

  if (!account) {
    return null;
  }

  if (!status) {
    return null;
  }

  if (status.isActive) {
    return null;
  }

  return (
    <Row className={Styles.container(findType())} justify='center'>
      <Col className={cx(Display.flex, JustifyContent.center, Styles.col)} span={24}>
        <ExclamationCircleOutlined className={Styles.icon(findType())} />
        {findMessage()}
      </Col>
    </Row>
  );
};
